const storyList = [
    {
     description: 'OGP TEAM meets with Government and Civil Society',
     imgUrl: ''
    },
    {
     description: 'OGP Nigeria: The Journey so far',
     imgUrl: '../../assets/img/storyImage2.jpg'
    },
    {
     description: 'OGP Nigeria: The Journey so far',
     imgUrl: '',
     isLast: true,
    },
];

export default storyList;
